<template>
    <v-card>
      <v-card-title>
        <span>Dashboard</span>
      </v-card-title>
      <v-card-text>
<!--        <v-menu-->
<!--          ref="menu1"-->
<!--          v-model="menu1"-->
<!--          :close-on-content-click="false"-->
<!--          transition="scale-transition"-->
<!--          :return-value.sync="dates"-->
<!--          offset-y-->
<!--          min-width="290px"-->
<!--        >-->
<!--          <template v-slot:activator="{ on, attrs }">-->
<!--            <v-text-field-->
<!--              v-model="dateRangeText"-->
<!--              label="Selecione o Período"-->
<!--              persistent-hint-->
<!--              prepend-icon="mdi-calendar"-->
<!--              readonly-->
<!--              v-bind="attrs"-->
<!--              v-on="on"-->
<!--            ></v-text-field>-->
<!--          </template>-->
<!--          <v-date-picker-->
<!--            v-model="dates"-->
<!--            locale="pt-br"-->
<!--            no-title-->
<!--            range-->
<!--          >-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-btn-->
<!--              text-->
<!--              color="primary"-->
<!--              @click="menu1 = false"-->
<!--            >-->
<!--              Cancelar-->
<!--            </v-btn>-->
<!--            <v-btn-->
<!--              text-->
<!--              color="primary"-->
<!--              @click="$refs.menu1.save(dates)"-->
<!--            >-->
<!--              OK-->
<!--            </v-btn>-->
<!--          </v-date-picker>-->
<!--        </v-menu>-->
        <v-row no-gutters>
        <Cards :numberOfReceived="numberOfReceived" :numberOfSent="numberOfSent" :numberOfRead="numberOfRead"/>
        </v-row>
        <v-row no-gutters class="d-flex justify-center">
          <PieChart :numberOfReceived="numberOfReceived" :numberOfSent="numberOfSent" :numberOfRead="numberOfRead"/>
        </v-row>
      </v-card-text>

    </v-card>
</template>

<script>

import Cards from "./CardsInfor.vue";
import PieChart from "./PieChart.vue";

export default {
  name: "DashboardMain",
  components:{
    Cards,
    PieChart
    // TheSalesOverview: () => import('../dashboard/TheSalesOverview'),
  },
  apollo: {
    dashboardData: {
      query: require("@/graphql/queries/Dashboard.gql").getDashboardData,
      variables() {
        return {
          range: this.dates ? this.dates : null
        }
      },
      update: (data) => data.dashBoardQuery,
    },
  },
  watch: {
    dashboardData(val) {
      console.log()
      if (typeof val.numberOfReceived == 'number') {
        this.numberOfReceived = val.numberOfReceived
        this.numberOfSent = val.numberOfSent
        this.numberOfRead = val.numberOfRead
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  data() { 
    return {
      numberOfReceived: 0,
      numberOfSent: 0,
      numberOfRead: 0,
      date: null,
      dates: null,
      dateFormatted: null,
      menu1: false
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      if (!this.dates) {
        return null
      }

      const [year, month, day] = this.dates[0].split('-')
      if (this.dates.length == 1) {
        return `${day}/${month}/${year}` 
      }

      const [year2, month2, day2] = this.dates[1].split('-')
      return `${day}/${month}/${year} a ${day2}/${month2}/${year2}`
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  }
}
</script>
